module.exports = __webpack_public_path__ + "img/1.d17af023.png";